<template>
  <div class="gift-item noSelect" @click="onSubmitPay(item)">
    <div class="gift-img-box">
      <img class="gift-img" :src="API_URL+item.image" alt="">
    </div>
    <div class="gift-info-box">
      <div class="gift-info-top">
        <span class="gift-name">{{item.product_name}}</span>
        <span class="gift-other">{{item.weight}}kg/件</span>
      </div>
      <div class="gift-icon">
        <img v-for="(item, index) in stocksFilter(item.stocks)" :key="index" class="gift-icon-item" :src="IMG_URL+item" alt="">
      </div>
      <div class="gift-info-footer">
        <span class="gift-price">￥{{item.price}}</span>
      </div>
    </div>
    <div class="submit-btn" @click="onSubmitPay(item)">立即下单</div>
  </div>
</template>

<script>
export default {
  name: "giftItem",
  props: {
    item: {
      type: Object,
      default: function (val) {
        return val || {}
      },
    },
    source: {
      type: Number,
      default: 0
    },
    path: { //判断是否礼品商城页面
      type: String,
      default: ""
    }
  },
  data() {
    return {

    }
  },
  methods:{
    stocksFilter(data) {
      var gift = data[0];
      var sourceList = [
        {name: '淘宝', icon: "images/order/tb-icon.png"},
        {name: '天猫', icon: 'images/order/tb-icon.png'},
        {name: '京东', icon: 'images/order/jd-icon.png'},
        {name: '拼多多', icon: 'images/order/pdd-icon.png'},
        {name: '快手', icon: 'images/order/ks-icon.png'},
        {name: '抖音', icon: 'images/order/dy-icon.png'}
      ];
      var express = gift.depot_name.split('礼品')[1];
      if (!express) {
        express = gift.depot_name.split('自提')[1];
      }
      if(!express){
        express = gift.depot_name;
      }
      var express2 = express.split("【");
      var p_data = [];
      express2.forEach(item => {
        const name = item.split("】");
        for (let i = 0; i < sourceList.length; i++) {
          if (name[0].indexOf(sourceList[i].name) !== -1) {
            p_data.push(sourceList[i].icon)
          }
        }
      })
      return p_data
    },
    getSourceIndex(name) {
      var depot = ''
      if (name.indexOf('淘宝') !== -1) {
        depot = 0
      } else if (name.indexOf('拼多多') !== -1) {
        depot = 2
      } else if (name.indexOf('京东') !== -1) {
        depot = 1
      } else if (name.indexOf('快手') !== -1) {
        depot = 5
      } else if (name.indexOf('抖音') !== -1) {
        depot = 4
      } else {
        depot = 3
      }
      return depot
    },
    //立即下单
    onSubmitPay(item){
      var source =  0;
      if(this.path == 'product'){
        source = this.source;
      }else{
        source = this.getSourceIndex(item.stocks[0].depot_name);
      }
      console.log(source);
      var row = { depot_id: item.stocks[0].depot_id, product_id: item.id, source: source, gift: item}
      localStorage.setItem('giftData', JSON.stringify(row))
      this.$router.push('/order/add')
    },
  }
}
</script>

<style scoped lang="scss">
.gift-item {
  width: 290px;
  height: 360px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
  box-sizing: border-box;
  margin-right: 13px;
  margin-bottom: 13px;


  .gift-img-box {
    width: 290px;
    box-sizing: border-box;

    .gift-img {
      width: 100%;
      height: 260px;
      display: block;
    }
  }

  .gift-info-box {
    padding: 20px;
    background-color: #ffffff;

    .gift-info-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .gift-name {
        font-weight: bold;
        color: #000;
        margin-bottom: 5px;

      }

      .gift-other {
        font-size: 12px;
        color: #999999;
      }
    }

    .gift-icon {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      .gift-icon-item {
        width: 18px;
        height: 18px;
        border-radius: 4px;
        margin-right: 6px;
      }
    }

    .gift-info-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .gift-price {
        color: #0f375a;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }

  &:hover {
    border: 1px solid #0f375a;

    .gift-info-box {
      background-color: #0f375a;
    }

    .gift-name {
      color: #ffffff !important;
    }

    .gift-price {
      color: #ffffff !important;
    }

    .gift-other {
      color: #ffffff !important;
    }

    .submit-btn {
      bottom: 20px;
    }
  }

  .submit-btn {
    position: absolute;
    right: 20px;
    bottom: -50px;
    padding: 5px 10px;
    background-color: #ffffff;
    color: #000000;
    font-size: 14px;
    transition: all 500ms ease;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/giftItem/index.vue